import { ReportColumnConfig } from 'components/ReportGrid_New/types';

export const CORE_MI_REPORT = 'Core MI Report';
export const CORE_MI_REPORT_GRID_TITLE = 'CoreMIReport';
export const CORE_MI_REPORT_TITLE_INFO_MESSAGE =
  'Provides a complete breakdown of all core information on a claim by claim basis for your chosen date range or where the initial work completed date is within your chosen date range';

export const columns: ReportColumnConfig[] = [
  { name: 'name', title: 'Name', width: '100' },
  { name: 'siteCode', title: 'Site Code' },
  { name: 'repairerGroup', title: 'Repairer Group' },
  { name: 'stream', title: 'Stream' },
  { name: 'insurerName', title: 'Insurer Name' },
  { name: 'claimReference', title: 'Claim Reference' },
  { name: 'regMark', title: 'Reg Mark' },
  { name: 'claimId', title: 'Claim Id' },
  { name: 'status', title: 'Status' },
  { name: 'statusDTG', title: 'Status DTG', type: 'date' },
  { name: 'manufacturer', title: 'Manufacturer' },
  { name: 'model', title: 'Model' },
  { name: 'vehicleMobile', title: 'Vehicle Mobile' },
  { name: 'labourHours', title: 'Labour Hours', type: 'number' },
  {
    name: 'labourCost',
    title: 'Labour Cost',
    type: 'currency',
  },
  {
    name: 'partsCost',
    title: 'Parts Cost',
    type: 'currency',
  },
  {
    name: 'paintCost',
    title: 'Paint Cost',
    type: 'currency',
  },
  {
    name: 'otherCost',
    title: 'Other Cost',
    type: 'currency',
  },
  {
    name: 'totalCost',
    title: 'Total Cost',
    type: 'currency',
  },
  { name: 'ownerExcess', title: 'Owner Excess', type: 'number' },
  { name: 'courtesyCarProvided', title: 'Courtesy Car Provided' },
  { name: 'courtesyCar', title: 'Courtesy Car' },
  { name: 'courtesyCarOut', title: 'Courtesy Car Out' },
  { name: 'ownerMobileNumber', title: 'Owner Mobile Number' },
  { name: 'ownerEmail', title: 'Owner Email' },
  { name: 'createdDate', title: 'Created Date', type: 'date' },
  { name: 'bookedInDate', title: 'Booked-In Date', type: 'date' },
  { name: 'onSiteDate', title: 'On-Site Date', type: 'date' },
  { name: 'partsOrderedDate', title: 'Parts Ordered Date', type: 'date' },
  { name: 'workStartedDate', title: 'Work Started Date', type: 'date' },
  { name: 'workCompletedDate', title: 'Work Completed Date', type: 'date' },
  { name: 'bookedOutDate', title: 'Booked-Out Date', type: 'date' },
  { name: 'offSiteDate', title: 'Off-Site Date', type: 'date' },
  { name: 'invoiceDate', title: 'Invoice Date', type: 'date' },
  { name: 'ecdDate', title: 'ECD Date', type: 'date' },
  { name: 'liabilityImpact', title: 'Liability Impact' },
  { name: 'initialBookInDate', title: 'Initial Booked-In Date', type: 'date' },
  {
    name: 'initialBookOutDate',
    title: 'Initial Booked Out Date',
    type: 'date',
  },
  {
    name: 'bookInDateChanges',
    title: 'Booked In Date Changes',
    type: 'number',
  },
  {
    name: 'bookOutDateChanges',
    title: 'Booked Out Date Changes',
    type: 'number',
  },
  { name: 'initialECDDate', title: 'Initial ECDDate', type: 'date' },
  { name: 'ecdDateChanges', title: 'ECDDate Changes', type: 'number' },
  { name: 'cT_FNOL_OnSite', title: 'CT FNOL On Site', type: 'number' },
  { name: 'cT_Key_2_Key', title: 'CT Key 2 Key', type: 'number' },
  { name: 'cT_CycleTime', title: 'CT Cycle Time', type: 'number' },
  { name: 'within15Days', title: 'Within15Days' },
  { name: 'within21Days', title: 'Within21Days' },
  { name: 'webPortalUsage', title: 'Web Portal Usage', type: 'number' },
  { name: 'smsMessages', title: 'SMSMessages', type: 'number' },
  { name: 'hashTags', title: 'Hash Tags' },
  { name: 'initialOnSiteDate', title: 'Initial On Site Date', type: 'date' },
  {
    name: 'initialWorkCompletedDate',
    title: 'Initial Work Completed Date',
    type: 'date',
  },
  { name: 'replacementVehicleCode', title: 'Courtesy Car Required' },
  { name: 'dtgFnol', title: 'Fnol Date', type: 'date' },
  { name: 'dtgFirstActivity', title: 'First Activity Date', type: 'date' },
  {
    name: 'vehicleStillOnSite',
    title: 'Vehicle Still On Site',
  },
];
